import { Stack, Textarea } from "@mantine/core";
import React from "react";
import FileUploader from "../FileUploader/FileUploader";

const InputUpload: React.FC<{ text: string; setText: (str: string) => void }> = ({ text, setText }) => {
  const onFileUpload = (file: File) => {
    if (file.name.endsWith(".txt") === false) {
      alert("Du kan kun laste opp .txt-filer");
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const fileContent = reader.result;
      if (typeof fileContent !== "string") {
        alert("Kunne ikke lese filen");
        return;
      } else {
        setText(fileContent);
      }
    };

    reader.readAsText(file, "ISO-8859-1"); // Lägg till teckenkodningen här
  };

  return (
    <Stack gap="sm">
      <FileUploader onFileUpload={onFileUpload} files={[]} />

      <Textarea
        placeholder="Skriv eller lim inn tekst her..."
        value={text}
        onChange={(event) => setText(event.currentTarget.value)}
        autosize
        minRows={3}
        maxRows={10}
      />
    </Stack>
  );
};

export default InputUpload;
